import React, { useState } from 'react';
import './contact.style.scss';
import Footer from '../../components/footer/footer.comp';
import Navbar from '../../components/navbar/navbar.comp';
import { addEmailToFirestore } from '../../utils/firebase/firebase.utils'
import Button from '../../components/button/button.comp';

const Contact = () => {
    // State to hold the form values
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });

    // Function to handle input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });

    };

    // Handle form submission
    const [loadedBoolean, setLoadedBoolean] = useState(false)
    const [response, setResponse] = useState(false)
    const [popUp, setPopUp] = useState(false)
    const handleSubmit = async (e) => {
        e.preventDefault();
        setPopUp(true)
        try {
            await addEmailToFirestore(formData);  // Use the utility function
            // Clear the form
            setFormData({
                name: '',
                email: '',
                subject: '',
                message: ''
            });

            setLoadedBoolean(true)
            setResponse(true)
        } catch (error) {
            console.error("Failed to send email:", error);
            setLoadedBoolean(false)
        }
    };
    const handleClosePopUp = () => {
        console.log('close')
        setPopUp(false)
        setResponse(false)
        setLoadedBoolean(false)
    }

    return (
        <div>
            {/* Navbar */}
            <div className='section'>
                <Navbar />
            </div>

            {/* Main Section */}
            <div
                className='section text-section frame contact'
                style={{ color: 'var(--fontlightblack1)' }}
            >
                <h1 style={{ color: 'var(--fontlightblack1)' }}>Contact Us</h1>
                <p>If you have any questions or need further assistance, feel free to reach out to us. We'd love to hear from you!</p>

                <form className="contact-form" onSubmit={handleSubmit}>
                    <label htmlFor="name">Your Name:</label>
                    <input
                        type="text"
                        id="name"
                        name="name"
                        placeholder="Enter your name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                    />

                    <label htmlFor="email">Your Email:</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        placeholder="Enter your email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                    />

                    <label htmlFor="subject">Subject:</label>
                    <select
                        id="subject"
                        name="subject"
                        value={formData.subject}
                        onChange={handleInputChange}
                        required
                    >
                        <option value="">Select a subject</option>
                        <option value="careers">Careers</option>
                        <option value="general">General Inquiry</option>
                        <option value="support">Support Request</option>
                        <option value="feedback">Feedback</option>
                        <option value="partnership">Partnership Opportunities</option>
                        <option value="legal">Legal</option>
                        <option value="other">Other</option>
                    </select>

                    <label htmlFor="message">Your Message:</label>
                    <textarea
                        id="message"
                        name="message"
                        placeholder="Enter your message"
                        rows="5"
                        value={formData.message}
                        onChange={handleInputChange}
                        required
                    ></textarea>

                    {/* Conditional Rendering for Submit Button */}
                    {
                        formData.name && formData.email && formData.subject && formData.message ? (
                            <button
                                type="submit"
                                className="submit-button"
                            >
                                Send Message
                            </button>
                        ) : (
                            <button
                                type="submit"
                                className="submit-button disabled"
                                disabled
                            >
                                Send Message
                            </button>
                        )
                    }
                    <p style={{ fontSize: 'small' }}>We aim to respond in 7 business days</p>
                </form>
            </div>

            {/* Footer Margin */}
            <div className="footer-margin"></div>

            {/* Footer */}
            <Footer />

            {/* Pop Up */}
            {
                popUp ? (
                    <div className="save-pop-up-container">
                        <div className="save-pop-up">
                            <div className="save-pop-up-header">
                                <div className="title">
                                    <div
                                        className="close pointer"
                                        style={{
                                            backgroundImage: `url(${'https://logowik.com/content/uploads/images/close1437.jpg'})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat'
                                        }}
                                        onClick={handleClosePopUp}>
                                    </div>
                                </div>
                            </div>
                            {
                                !loadedBoolean ? (
                                    <div style={{ display: 'flex', alignItems: 'center' }} className="save-pop-up-scroll-view ">
                                        <p style={{ fontSize: 'large', textAlign: "center" }} >Sending...</p>
                                        <div className="this-week-loading-circle"></div>
                                    </div>
                                ) : (
                                    response ? (
                                        <div style={{ display: 'flex', alignItems: 'center' }} className="save-pop-up-scroll-view ">
                                            <p style={{ fontSize: 'large', textAlign: "center" }} >Email Sent!</p>
                                            <p style={{ textAlign: "center" }} >Thank you for contacting us. We aim to respond in 7 business days.</p>
                                            <Button text={'Close'} option={'yellow'} onClick={handleClosePopUp} />
                                        </div>
                                    ) : (
                                        <div style={{ display: 'flex', alignItems: 'center' }} className="save-pop-up-scroll-view ">
                                            <p style={{ fontSize: 'large', textAlign: "center" }} >Error</p>
                                            <p style={{ textAlign: "center" }} >There was an error, please try submitting response again.</p>
                                            <Button text={'Close'} option={'yellow'} onClick={handleClosePopUp} />
                                        </div>

                                    )
                                )
                            }
                        </div>
                    </div>
                ) : null
            }

        </div >
    );
};

export default Contact;
